module.exports = __webpack_public_path__ + "static/20-db13e7010a1e04e19eb3480730098d91.png";